// DS: C27
// TODO nuke from high orbit :)
// TODO port this to streams - https://phrac.deviantart.net/D23153
// TODO add error handling
// TODO convert to use tooltip library
import React, { useState, useEffect, useRef, useCallback } from 'react';
import FocusTrap from 'focus-trap-react';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import NoLeakyScroll from '../NoLeakyScroll';
import { EmoteStreamType } from './redux/types';
import { streamTypeToSearchType } from './constants';
import TabsHeader from './TabsHeader';
import EmoteSelectorPopupWrapper from './EmoteSelectorPopupWrapper';
import EmoteList from './EmoteList';
import SearchHeader from './SearchHeader';
import { useInView } from 'react-intersection-observer';
import s from './EmoteSelector.scss';
const Sentinal = ({ onFetchMore })=>{
    const [ref, inView] = useInView();
    if (inView) {
        onFetchMore();
    }
    return /*#__PURE__*/ React.createElement("div", {
        ref: ref
    });
};
export const EmoteSelector = ({ activeStream, isLoading, onLoadMore, buttonRect, isLoadingStream, switchStream, onEmoteSelect, onInitialize, onClose })=>{
    const scrollContainerRef = useRef(null);
    const [isSearchOpen, setIsSearchOpen] = useState(false);
    useEffect(()=>{
        onInitialize();
    }, [
        onInitialize
    ]);
    const resetScroll = useCallback(()=>{
        if (scrollContainerRef.current) {
            scrollContainerRef.current.children[0].scrollTop = 0;
        }
    }, [
        scrollContainerRef
    ]);
    const closeSearch = useCallback(()=>{
        switchStream({
            streamType: EmoteStreamType.OFFICIAL,
            searchType: streamTypeToSearchType[EmoteStreamType.OFFICIAL],
            searchQuery: ''
        });
        setIsSearchOpen(false);
    }, [
        switchStream
    ]);
    const handleEmoteSelect = useCallback((emote, e)=>{
        onEmoteSelect(emote);
        if (e && e.shiftKey) {
            return;
        }
        if (onClose) onClose({});
    }, [
        onClose,
        onEmoteSelect
    ]);
    const openSearch = useCallback(()=>{
        resetScroll();
        setIsSearchOpen(true);
    }, [
        resetScroll,
        setIsSearchOpen
    ]);
    return /*#__PURE__*/ React.createElement(FocusTrap, {
        focusTrapOptions: {
            clickOutsideDeactivates: true,
            onDeactivate: ()=>{
                if (onClose) {
                    onClose({});
                }
            }
        }
    }, /*#__PURE__*/ React.createElement(EmoteSelectorPopupWrapper, {
        buttonRect: buttonRect
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['header']
    }, isSearchOpen && /*#__PURE__*/ React.createElement(SearchHeader, {
        onClose: closeSearch
    }), !isSearchOpen && /*#__PURE__*/ React.createElement(TabsHeader, {
        onOpenSearch: openSearch
    })), /*#__PURE__*/ React.createElement("div", {
        className: s['items'],
        ref: scrollContainerRef
    }, /*#__PURE__*/ React.createElement(NoLeakyScroll, {
        className: s['scroll-area']
    }, !isLoadingStream && /*#__PURE__*/ React.createElement(EmoteList, {
        onEmoteSelect: handleEmoteSelect
    }), (isLoading || isLoadingStream) && /*#__PURE__*/ React.createElement(LoadingIndicator, {
        view: "llama",
        className: s['loading']
    }), onLoadMore && (activeStream === null || activeStream === void 0 ? void 0 : activeStream.hasMore) && !isLoading && /*#__PURE__*/ React.createElement(Sentinal, {
        onFetchMore: onLoadMore
    })))));
};
export default EmoteSelector;

//# sourceMappingURL=EmoteSelector.js.map